import type { OrderbookItem } from '@/types/otc'
import type { OrderType, DealType, SortBy, SortDirection } from '@/types/otc'

export interface OrderbookTableContentBaseProps {
  data: OrderbookItem[]
  isLoading?: boolean
  onRowClick?: (item: OrderbookItem) => void
  emptyMessage?: string
  sortColumn?: string
  sortDirection?: 'asc' | 'desc'
  onSort?: (columnKey: string) => void
  // Mobile filters props
  search?: string
  onSearchChange?: (value: string) => void
  type?: OrderType | ''
  onTypeChange?: (value: OrderType | '') => void
  assetType?: DealType | ''
  onAssetTypeChange?: (value: DealType | '') => void
  trancheSize?: string
  onTrancheSizeChange?: (value: string) => void
  sortBy?: SortBy | ''
  onSortByChange?: (value: SortBy | '') => void
  sortDirectionFilter?: SortDirection | ''
  onSortDirectionChange?: (value: SortDirection | '') => void
  onFilterButtonClick?: () => void
}

// Format date as DD/MM/YYYY
export const formatDateDDMMYYYY = (date: string | null | undefined): string => {
  if (!date) return '—'
  try {
    const d = new Date(date)
    if (isNaN(d.getTime())) return '—'
    const day = String(d.getDate()).padStart(2, '0')
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const year = d.getFullYear()
    return `${day}/${month}/${year}`
  } catch {
    return '—'
  }
}

